 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~main-pages-pages-module~orders-orders-module~products-products-module~reclamation-list-recla~98fdad3f":"default~main-pages-pages-module~orders-orders-module~products-products-module~reclamation-list-recla~98fdad3f","default~main-pages-pages-module~main-ui-ui-module~orders-orders-module~products-products-module":"default~main-pages-pages-module~main-ui-ui-module~orders-orders-module~products-products-module","default~main-pages-pages-module~orders-orders-module":"default~main-pages-pages-module~orders-orders-module","main-pages-pages-module":"main-pages-pages-module","default~main-ui-ui-module~orders-orders-module~products-products-module~reclamation-list-reclamation~24db6f42":"default~main-ui-ui-module~orders-orders-module~products-products-module~reclamation-list-reclamation~24db6f42","default~main-ui-ui-module~orders-orders-module~products-products-module~shop-shop-module~users-users-module":"default~main-ui-ui-module~orders-orders-module~products-products-module~shop-shop-module~users-users-module","default~components-third-party-components-third-party-module~main-ui-ui-module~orders-orders-module~~99a962c3":"default~components-third-party-components-third-party-module~main-ui-ui-module~orders-orders-module~~99a962c3","default~main-ui-ui-module~shop-shop-module":"default~main-ui-ui-module~shop-shop-module","main-ui-ui-module":"main-ui-ui-module","main-apps-apps-module":"main-apps-apps-module","main-authentication-authentication-module":"main-authentication-authentication-module","main-documentation-documentation-module":"main-documentation-documentation-module","dashboard-dashboard-module":"dashboard-dashboard-module","default~components-third-party-components-third-party-module~orders-orders-module~products-products-~ef19a9ce":"default~components-third-party-components-third-party-module~orders-orders-module~products-products-~ef19a9ce","default~orders-orders-module~products-products-module~users-users-module":"default~orders-orders-module~products-products-module~users-users-module","orders-orders-module":"orders-orders-module","products-products-module":"products-products-module","users-users-module":"users-users-module","reclamation-list-reclamation-list-module":"reclamation-list-reclamation-list-module","shop-shop-module":"shop-shop-module","dispatcher-dispatcher-module":"dispatcher-dispatcher-module","components-components-module":"components-components-module","components-third-party-components-third-party-module":"components-third-party-components-third-party-module","directives-directives-module":"directives-directives-module","getting-started-getting-started-module":"getting-started-getting-started-module","services-services-module":"services-services-module","working-with-fuse-working-with-fuse-module":"working-with-fuse-working-with-fuse-module"}[chunkId]||chunkId) + "-es2015." + {"default~main-pages-pages-module~orders-orders-module~products-products-module~reclamation-list-recla~98fdad3f":"45442b24396fc30e8535","default~main-pages-pages-module~main-ui-ui-module~orders-orders-module~products-products-module":"c6ceeb4d1334e155402b","default~main-pages-pages-module~orders-orders-module":"8133472b5c1c3051f357","main-pages-pages-module":"695d3d5dc133e4b1951c","default~main-ui-ui-module~orders-orders-module~products-products-module~reclamation-list-reclamation~24db6f42":"f7661af5b9bf50fdf174","default~main-ui-ui-module~orders-orders-module~products-products-module~shop-shop-module~users-users-module":"8eb9168051ac533eba77","default~components-third-party-components-third-party-module~main-ui-ui-module~orders-orders-module~~99a962c3":"0261df0e97098b9dd451","default~main-ui-ui-module~shop-shop-module":"2580c413b83f895e1997","main-ui-ui-module":"a5a54a2b67a69c780c65","main-apps-apps-module":"9b27cc4aaf53719b90b5","main-authentication-authentication-module":"610c7e14857e5c6b2101","main-documentation-documentation-module":"0a37741c2c01c31f3356","dashboard-dashboard-module":"635220bdc6acd97ef773","default~components-third-party-components-third-party-module~orders-orders-module~products-products-~ef19a9ce":"1166108641072a6b404a","default~orders-orders-module~products-products-module~users-users-module":"168dcdf033a3cf1dce0e","orders-orders-module":"40ff6a70988eea4bec0f","products-products-module":"fdc21fbbc64809ce3ea1","users-users-module":"aa32ca69a88fbf1b0b59","reclamation-list-reclamation-list-module":"62c6ec9d07c1142e47ba","shop-shop-module":"a0b10eefecafa4cba0dd","dispatcher-dispatcher-module":"c755221508ba4b50e4b4","components-components-module":"bb0d521add09ab5c5517","components-third-party-components-third-party-module":"52c71a2e42147f1de6d4","directives-directives-module":"6698d42ab3b2046dda29","getting-started-getting-started-module":"7c340428c68b1c93a897","services-services-module":"f1a4061f37e56d2e89cb","working-with-fuse-working-with-fuse-module":"087d1a7b83164b98b65b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
